import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCRegisterCarDetran = class UiCRegisterCarDetran {
    constructor() {
        this.onChange = new EventEmitter();
    }
    ngOnInit() { }
    onChangeForm() {
        this.onChange.emit(this.createVehicleForm);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRegisterCarDetran.prototype, "listStates", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRegisterCarDetran.prototype, "createVehicleForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRegisterCarDetran.prototype, "errorMessages", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRegisterCarDetran.prototype, "onChange", void 0);
UiCRegisterCarDetran = __decorate([
    Component({
        selector: 'ui-c-register-car-detran',
        template: "<div class=\"ui-c-register-car-detran\">\n  <h4 class=\"ion-text-center title\">{{'CASH_OUT.DETRAN.LABELS.REGISTER_CAR'| wlpTranslate}}</h4>\n  <form [formGroup]=\"createVehicleForm\" (change)=\"onChangeForm()\">\n    <ion-list>\n      <ion-item>\n        <ion-label position=\"floating\">\n          {{'CASH_OUT.DETRAN.LABELS.SELECT_STATE'| wlpTranslate}}\n        </ion-label>\n        <ion-select [okText]=\"'CASH_OUT.DETRAN.BUTTONS.OK'| wlpTranslate\" formControlName=\"uf\"\n          [cancelText]=\"'CASH_OUT.DETRAN.BUTTONS.CANCEL'| wlpTranslate\">\n          <ion-select-option *ngFor=\"let item of listStates\" value=\"{{item.uf}}\">{{item.name}}</ion-select-option>\n        </ion-select>\n      </ion-item>\n\n      <ng-container>\n        <ion-item>\n          <ion-label position=\"floating\"> {{'CASH_OUT.DETRAN.LABELS.RENAVAM'| wlpTranslate}}</ion-label>\n          <ion-input formControlName=\"renavam\" type=\"text\" placeholder=\"XXXXXXXXXXXXX\"></ion-input>\n        </ion-item>\n        <div class=\"error-messages\">\n          <ng-container *ngFor=\"let error of errorMessages.renavam\">\n            <div class=\"error-message\" *ngIf=\"\n              createVehicleForm.get('renavam').hasError(error.type) &&\n              (createVehicleForm.get('renavam').dirty || createVehicleForm.get('renavam').touched)\n            \">\n              {{ error.message | wlpTranslate: error?.param }}\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n\n      <ng-container>\n        <ion-item>\n          <ion-label position=\"floating\"> {{'CASH_OUT.DETRAN.LABELS.DESCRIPTION'| wlpTranslate}}</ion-label>\n          <ion-input formControlName=\"description\" type=\"text\" maxlength=\"30\" placeholder=\"XXXXXXXXXXXXX\"></ion-input>\n        </ion-item>\n\n        <div class=\"error-messages\">\n          <ng-container *ngFor=\"let error of errorMessages.description\">\n            <div class=\"error-message\" *ngIf=\"\n              createVehicleForm.get('description').hasError(error.type) &&\n              (createVehicleForm.get('description').dirty || createVehicleForm.get('description').touched)\n            \">\n              {{ error.message | wlpTranslate: error?.param }}\n            </div>\n          </ng-container>\n        </div>\n\n      </ng-container>\n\n    </ion-list>\n  </form>\n</div>"
    }),
    __metadata("design:paramtypes", [])
], UiCRegisterCarDetran);

let UiCRegisterCarDetranModule = class UiCRegisterCarDetranModule {
};
UiCRegisterCarDetranModule = __decorate([
    NgModule({
        declarations: [UiCRegisterCarDetran],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCRegisterCarDetran]
    })
], UiCRegisterCarDetranModule);

export { UiCRegisterCarDetran, UiCRegisterCarDetranModule };
//# sourceMappingURL=wlp-ui-c-register-car-detran.js.map
